import React from 'react';
import Button from '../../../components/ui/Button';

const BulkActionsBar = ({ selectedCount, language, onExport, onClearSelection }) => {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[100] bg-primary text-primary-foreground rounded-lg shadow-elevation-lg px-6 py-4 flex items-center gap-4">
      <span className="font-medium">
        {selectedCount} {language === 'ar' ? 'محدد' : language === 'fr' ? 'sélectionné(s)' : 'selected'}
      </span>
      
      <div className="flex items-center gap-2">
        <Button
          variant="secondary"
          size="sm"
          onClick={onExport}
          iconName="Download"
          iconPosition="left"
          iconSize={14}
        >
          {language === 'ar' ? 'تصدير' : language === 'fr' ? 'Exporter' : 'Export'}
        </Button>
        
        <Button
          variant="ghost"
          size="sm"
          onClick={onClearSelection}
          iconName="X"
          iconSize={14}
        >
          {language === 'ar' ? 'إلغاء' : language === 'fr' ? 'Annuler' : 'Clear'}
        </Button>
      </div>
    </div>
  );
};

export default BulkActionsBar;